<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g id="Group_3292" data-name="Group 3292" transform="translate(0.153)">
      <g
        id="Download_icon"
        data-name="Download icon"
        transform="translate(-0.153)"
      >
        <g
          id="Ellipse_202"
          data-name="Ellipse 202"
          fill="none"
          stroke="#b40068"
          stroke-width="2"
        >
          <circle cx="12" cy="12" r="12" stroke="none" />
          <circle cx="12" cy="12" r="11" fill="none" />
        </g>
        <g id="Group_2162" data-name="Group 2162" transform="translate(7 6)">
          <path
            id="Path_1808"
            data-name="Path 1808"
            d="M11,0H0"
            transform="translate(5) rotate(90)"
            fill="none"
            stroke="#b40068"
            stroke-width="2"
          />
          <path
            id="Path_1809"
            data-name="Path 1809"
            d="M0,10,5,5,0,0"
            transform="translate(10 6) rotate(90)"
            fill="none"
            stroke="#b40068"
            stroke-width="2"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'DocumentDownload',
}
</script>

<style lang="scss" scoped></style>
